export const ASSET_HOST = 'https://cdn.allbirds.com';
export const BASE_PATH = 'image/upload';
export const BASE_REMOTE_PATH = 'image/fetch';

export const IMAGE_HOST = '//cdn.allbirds.com/image/upload';
export const VIDEO_HOST = '//cdn.allbirds.com/video/upload';

export const CLOUDINARY_CONTENTFUL_AUTO_UPLOAD_FOLDER = 'cms';

export const V2_DEFAULT_TRANSFORMATIONS = {
  format: 'auto',
  quality: 'auto',
};
